

const TRANSLATIONS_NN_NO = {
    "email_otp.back":"Tilbake",
    "email_otp.enter_email_text":"Skriv inn e-postadressen din nedenfor så får du tilsendt en unik kode",
    "email_otp.send_verification_link":"Send verifiseringskode",
    "email_otp.resend_otp_with_timer":"Send ny kode om",
    "email_otp.text":"Vi har sendt en sekssifret verifiseringkode til [email]. Skriv inn koden nedenfor",
    "email_otp.verify":"Verifiser",
    "reset_password.set_password":"Skriv inn passord",
    "sign_in.or":"eller",
    "sign_in.continue_with":"Eller fortsett med",
    "sign_in.continue_with_email":"Eller fortsett med e-postadresse",
    "sign_in.create_without_password":"Opprett en konto uten passord",
    "sign_in.create_with_otp":"Opprett en konto med en engangskode",
    "sign_in.login_with_otp":"Logg inn med en engangskode",
    "sign_in.login_without_password":"Logg in uten passord",
    "sign_in.tooltip_text":"Du vil få tilsendt en e-post med en unik verifiseringskode for å få tilgang til kontoen din.",
    "sign_up.tooltip_text":"Du vil få tilsendt en e-post med en unik verifiseringskode for å opprette en konto.",
    "sign_in.password_updated":"Passordet ditt ble endret.",
    "sign_up.create_an_account":"Opprett en konto",
    "email_otp.resend_otp":"Send koden på nytt",
    "sign_up.email_address":"Epostadresse",
    "sign_up.password":"Passord",
    "sign_in.create_account" : "Opprett konto",
    "sign_in.title": "Logg Inn",
    "sign_in.forgot_password" : "Glemt passord?",
    "reset_password.resend_email": "Send ny e-post",
    "reset_password.sent_title": "E-posten ble sendt!",
    "reset_password.rcvResetLink": "Skriv inn e-postadressen din nedenfor, så sender vi deg en link for tilbakestilling av passord.",
    "reset_password.submit": "Send inn",
    "reset_password.back_to_login": "Tilbake til startsiden",
    "reset_password.create_new_password": "Lag et nytt passord for å logge inn på din konto.",
    "forgot_password.emailSent": "Hvis [] er knyttet til en konto, sender vi deg en e-post med en kobling til en side hvor du kan oppdatere passordet ditt. Fremdeles ingenting i innboksen? Be om en ny e-post under.",
    "gdpr.continue": "Fortsett",
    "validation.password_validation_heading": "Passordet må bestå av:",
    "validation.password_length_ui": "Minst 8 tegn",
    "validation.password_upper_case_ui": "minst én stor bokstav",
    "validation.password_lower_case_ui": "minst én liten bokstav",
    "validation.password_number_ui": "minst ett nummer",
    "validation.password_symbol_ui": "minst ett spesialtegn",
    "verify_otp.customer_service_center_link": "s/kundeservice",
    "activate_user.verification_successful.message": "Gratulerer! Kontoen din er aktivert.",
    "activate_user.already_verified.message" : "Velkommen tilbake! Kontoen din er allerede verifisert.",

    // Errors Translation
    "sign_in.mandatory_field_error": "Du må fylle inn alle de obligatoriske feltene før du går videre.",
    "sign_in.invalid_email_error": "E-postadressen må være i formatet navn@domene.no",
    "sign_in.invalid_credentials_error": "Brukernavnet eller passordet er ikke gyldig. Vennligst prøv på nytt.",
    "sign_in.generic_error": "Det oppsto en feil. Vennligst prøv på nytt.",
    "sign_in.account_unverified_error": "Kontoen din er ikke aktivert. Se etter aktiveringslenken i innboksen din, eller klikk «Glemt passordet?» for å få tilgang til kontoen din igjen.",
    "sign_in.max_attempt_error": "Du har nådd maksimalt antall forsøk. Prøv igjen om en stund.",
    "sign_in.social_signin_error": "Pålogging via sosiale nettverk (Google/facebook/apple) var ikke mulig. Prøv igjen eller bruk en annen påloggingsmetode.",
    "sign_in.social_signin_email_not_present_error": "Klarte ikke å logge deg på. Prøv på nytt eller bruk en annen type pålogging.",
    "sign_in.guest_user_signin_error": "Det virker som du allerede har en konto knyttet til denne e-postadressen. Klikk «Glemt passord?» for å tilbakestille passordet ditt.",

    "sign_up.mandatory_field_error": "Du må fylle inn alle de obligatoriske feltene før du går videre.",
    "sign_up.invalid_email_error": "Oppgi en gyldig e-postadresse, som f.eks. navn@domene.no",
    "sign_up.password_length_error": "Passordet må ha minst åtte tegn.",
    "sign_up.email_already_exist_error": "Denne e-postadressen er allerede i bruk. Du må bruke en annen e-postadresse.",
    "sign_up.generic_error": "Det oppsto en feil. Vennligst prøv på nytt.",
    "sign_up.password_policy_error": "Passordet må inneholde: et tall, et spesialtegn [!#$%&'*+-/=?^_`{|}~.@] og store og små bokstaver.",
    "sign_up.common_password_error": "Passordet kan ikke være e-postadressen din.",

    "forgot_password.mandatory_field_error": "Du må fylle inn alle de obligatoriske feltene før du går videre.",
    "forgot_password.invalid_email_error": "E-postadressen må være i formatet navn@domene.no",
    "forgot_password.generic_error": "Det oppsto en feil. Vennligst prøv på nytt.",

    "reset_password.mandatory_field_error": "Du må fylle inn alle de obligatoriske feltene før du går videre.",
    "reset_password.password_history_error": "Passordet må være ulikt de siste fem passordene.",
    "reset_password.password_length_error": "Passordet må ha minst åtte tegn.",
    "reset_password.password_policy_error": "Passordet må inneholde: et tall, et spesialtegn [!#$%&'*+-/=?^_`{|}~.@] og store og små bokstaver.",
    "reset_password.common_password_error": "Passordet kan ikke være e-postadressen din.",
    "reset_password.generic_error": "Det oppsto en feil. Vennligst prøv på nytt.",

    "email_otp.email_required_error": "Oppgi e-postadressen din for å fortsette.",
    "email_otp.invalid_email_error": "Oppgi en gyldig e-postadresse, som f.eks. navn@domene.no",
    "email_otp.generic_error": "Det oppsto en feil. Prøv igjen om en stund.",
    "email_otp.invalid_otp_error": "Passordet eller koden du oppga, er ikke gyldig. Vennligst prøv på nytt.",
    "email_otp.resend_otp_error": "Kunne ikke sende koden. Prøv igjen om en stund.",
    "email_otp.verify_otp_error": "Det oppsto en feil. Prøv å logge på med koden igjen om en stund.",
    "email_otp.verify_otp_limit_exceed_error": "Koden du oppga, er ikke gyldig. Klikk «Send ny kode» for å få tilsendt en ny.",
    "email_otp.max_attempt_reached_error": "Du har nådd maksimalt antall forsøk. Prøv igjen om en stund.",
    "email_otp.brute_force_error_part_1": "Kontoen din er midlertidig sperret på grunn av for mange påloggingsforsøk. Prøv igjen senere eller ta ",
    "email_otp.brute_force_error_part_2": "kontakt med kundeservice",
    "email_otp.brute_force_error_part_3": ".",
    "form.gdprconsent": "Ved å logge inn bekrefter du at du har lest og godkjenner",
    "form.termsCondition": "vilkårene",

    //Page Titles
    "sign_in.page_title": "Logg inn | Pens.com",
    "sign_up.page_title": "Meld Deg På | Pens.com",
    "forgot-password.page_title": "Glemt Passord | Pens.com",
    "reset-password.page_title": "Tilbakestill Passord | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_NN_NO;